module.exports = __webpack_public_path__ + "img/01.ad4a1998.jpg";